const getAbsolutePath = (image) => {
  return process.env.REACT_APP_DOMAIN + image;
}

export default getAbsolutePath;